export const SALARY_CURRENCIES = [
  'USD',
  'EUR',
  'GBP',
  'CAD',
  'AUD',
  'CHF',
  'JPY',
  'INR',
  'SGD',
  'AED',
  'NZD',
  'SEK',
  'NOK',
  'DKK',
];

export const SALARY_STRUCTURES = [
  { id: 'annual', label: 'Annual' },
  { id: 'monthly', label: 'Monthly' },
  { id: 'weekly', label: 'Weekly' },
  { id: 'daily', label: 'Daily' },
  { id: 'hourly', label: 'Hourly' },
  { id: 'project', label: 'Per project' },
];

const STRUCTURE_SHORT = {
  annual: 'year',
  monthly: 'month',
  weekly: 'week',
  daily: 'day',
  hourly: 'hour',
  project: 'project',
};

export const formatSalaryDisplay = ({
  salaryFrom,
  salaryTo,
  salaryCurrency,
  salaryStructure,
  salary,
} = {}) => {
  const currency = String(salaryCurrency || 'USD').trim().toUpperCase() || 'USD';
  const structure = String(salaryStructure || 'annual').trim().toLowerCase() || 'annual';
  const suffix = STRUCTURE_SHORT[structure] ? ` / ${STRUCTURE_SHORT[structure]}` : '';
  const from =
    salaryFrom === '' || salaryFrom === null || salaryFrom === undefined
      ? null
      : Number(salaryFrom);
  const to =
    salaryTo === '' || salaryTo === null || salaryTo === undefined ? null : Number(salaryTo);

  const fmt = (n) =>
    Number.isFinite(n) ? n.toLocaleString('en-US', { maximumFractionDigits: 0 }) : '';

  if (Number.isFinite(from) && Number.isFinite(to)) {
    return `${currency} ${fmt(from)} – ${fmt(to)}${suffix}`;
  }
  if (Number.isFinite(from)) return `${currency} ${fmt(from)}+${suffix}`;
  if (Number.isFinite(to)) return `Up to ${currency} ${fmt(to)}${suffix}`;
  return String(salary || '').trim();
};
